import { createSlice } from "@reduxjs/toolkit";

export const categorySlice = createSlice({
    name: "category",
    initialState: {
        categories: [],
        edit_category_id: null,
        editingCategory: null,
        loading: false,
        error: null,
    },
    reducers: {
        setLoading: (state) => {
            state.loading = true;
            state.error = null;
        },
        setCategories: (state, action) => {
            state.loading = false;
            state.error = null;
            state.categories = action.payload.data;
        },
        setError: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
        addCategory: (state, action) => {
            state.categories.push(action.payload);
        },
        setEditingCategoryId: (state, action) => {
            state.edit_category_id = action.payload;
        },
        setEditingCategory: (state, action) => {
            const categoryId = action.payload;
            const categoryToEdit = state.categories.find((category) => category.id === categoryId);
            if (categoryToEdit) {
                state.editingCategory = categoryToEdit;
            }
        },
        updateCategory: (state, action) => {
            const index = state.categories.findIndex(
                (category) => category.id === action.payload.id
            );
            if (index !== -1) {
                state.categories[index] = action.payload;
            }
            state.edit_category_id = null;
        }
    },
});

export const { setLoading, setCategories, addCategory, setEditingCategoryId, setError, setEditingCategory } = categorySlice.actions;

export default categorySlice.reducer;
